import swal from "sweetalert";
import {toast} from "react-toastify";  
import "react-toastify/dist/ReactToastify.css";
import './CommonFunction.css';
 
toast.configure();

export const checkFileSize = (uploadedFiles) => {
    var size = 0;
    uploadedFiles.forEach((x) => (size = size + parseInt(x.FileSize)));     
    if (size > 30000000) {
      swal("Error!", "Currently, uploaded files size is  "+ Math.round( size / 1000000) + "MB. Total files size should be less than 30MB.", "warning");
      return false;
    }    
    else{
      return true;
    }
  };


export  const checkFormat = async (uploadedFiles) =>
{
  var Files = [];
 
  var imageExtensions = ["jpg", "jpeg", "png", "gif", "bmp", "svg", "tiff", 
  "webp","ico", "jfif", "heic", "bat", "raw", "hdr", "dng","psd", "ai","eps"];

  
  for(let i = 0 ;i < uploadedFiles.length;i++)
  {
    if(imageExtensions.includes(uploadedFiles[i].name.split(".").pop().toLowerCase())){
      Files.push(uploadedFiles[i]);
    }  
  }  
   
  if (Files.length !== uploadedFiles.length) {
    await swal({
      title: "Error!",
      text: "Only images are allowed",
      icon: "warning",
    });
  }

  return Files;
};

export const successToast =  () => 
{  
  toast.success(
    <div style={{ fontSize: "16px", marginRight: "10px" }}>
      <span style={{ marginRight: "5px" }}>&#10003;</span> Data saved successfully
    </div>,
    {
      position: "top-right",
      autoClose: 2000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    }
  );   
};

export const errorToast = () => 
{
  toast.error(
    <div style={{ fontSize: "16px", marginRight: "10px" }}>
      <span style={{ marginRight: "5px" }}>&#10007;</span> Something went wrong
    </div>,
    {
      position: "top-right",
      autoClose: 2000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    }
  );
  
};

export const deleteToast = () => 
{
  toast.success(
    <div style={{ fontSize: "16px", marginRight: "10px" }}>
      <span style={{ marginRight: "5px" }}>&#10003;</span> Deleted successfully
    </div>,
    {
      position: "top-right",
      autoClose: 2000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    }
  );
  
};